export const FOCUS_BLOCK_PLACEMENT = {
  INSERT: "insert",
  REPLACE: "replace",
};

export type FOCUS_BLOCK_PLACEMENT_TYPE =
  (typeof FOCUS_BLOCK_PLACEMENT)[keyof typeof FOCUS_BLOCK_PLACEMENT];
